import type { IMultiSelectEvenItem } from '../types/global';
import type { DynamicMultisectGetDataProps, MultisectDataItem } from '../types/modules/kendo-multiselect';

import type { BackMultiSelect } from './back-multiselect';

function bindResizeHeightMultiSelect() {
    $('[data-role=multiselect]').each(function () {
        const widget = $(this).data('kendoMultiSelect');
        if (!widget) {
            return;
        }
        const list = widget.list;
        const listParent = list.parent();
        const windowHeight = $(window).height() ?? 0;

        widget.bind('open', () => {
            const scrollTop = $(document).scrollTop() ?? 0;

            const posTop = widget.wrapper.offset()?.top ?? 0;
            const posBottom = posTop + 26;

            const maxHeight = Math.max(
                posTop - scrollTop,
                scrollTop + windowHeight - posBottom
            ) - 10;

            list.css('max-height', maxHeight);
            listParent.css('max-height', maxHeight);
        });
    });
}

function msSelectAll() {
    if (this.value().length === 1 && this.value().includes(-1)) {
        const multiselect = this.element.data('kendoMultiSelect');
        const multiselectData = multiselect.dataSource.data();
        let selectedValues = '';
        let strComma = '';
        for (let i = 0; i < multiselectData.length; i++) {
            const item = multiselectData[i];
            selectedValues += strComma + (item.Value?.toString() ? item.Value.toString() : item.IdToString);
            strComma = ',';
        }
        multiselect.value(selectedValues.split(','));
    }
}

function removeIsCatalogItems(e: kendo.ui.MultiSelectDataBoundEvent) {
    e.sender.dataItems().forEach((item: kendo.data.CatalogDataItem) => {
        if (item.IsCatalog) {
            e.sender.dataSource.remove(item);
        }
    });
}

/**
 * Для установки значений динмического мультиселекта, которых нет в dataItems
 * */
function updateDynamicMultiSelectItems(control: kendo.ui.MultiSelect, items: number[]) {
    const backControl = <BackMultiSelect>control;
    const dataItems = backControl.dataItems();
    const missingItems = items.filter((id) => !dataItems.some((item: kendo.data.ObservableObject) => id === item.get('id')));

    if (missingItems.length > 0) {
        const filterItem = {
            field: 'Text',
            operator: 'contains',
            value: items.join(',')
        };
        const filter: kendo.data.DataSourceFilter = {
            logic: 'and',
            filters: [filterItem]
        };

        backControl.dataSource.filter(filterItem);
        backControl.listView.setDSFilter(filter);
        backControl.value(items);
    }
}

function dynamicMultiSelectFilter(
    e: kendo.ui.MultiSelectFilteringEvent,
    comboName: string,
    additionalParams?: () => Record<string, unknown>
) {
    let txt = '';
    if (e.filter && e.filter.filters[0]) {
        txt = e.filter.filters[0].value;
    }
    else if (comboName) {
        comboName = comboName.replace(/\./g, '_');
        const combo = $(`#${comboName}`).data('kendoMultiSelect');

        if (combo) {
            txt = combo.value();
        }
    }

    const result = additionalParams?.() ?? {};
    result.text = txt.toString();
    return result;
}

function dynamicMultiselect_getData({ event, controlName, additionalParamsFunc }: DynamicMultisectGetDataProps) {
    const instance = window[controlName] ??= $(`#${controlName}`).data('kendoMultiSelect');
    const searchValue = event.filter?.filters.at(0)?.value;
    const result = additionalParamsFunc?.() ?? {};

    if (instance instanceof kendo.ui.MultiSelect) {
        const isFocus = instance.element.parent().hasClass('k-focus');
        const dataItems = instance.dataItems();
        const currentValues = dataItems.length > 0
            ? dataItems.map((x: MultisectDataItem) => x.Id || x.Name || x.Text).filter(Boolean).join(',')
            : instance.value().join(',');
        result.text = currentValues;

        if (instance._pendingRestoreIds) {
            result.text = instance._pendingRestoreIds.join(',');
            return result;
        }

        if (!isFocus) {
            result.text = currentValues || searchValue;
        }

        if (searchValue) {
            result.text = searchValue;
        }
    }

    return result;
}

function dataMultiSelectEvent(dataItem: IMultiSelectEvenItem) {
    /**
     * Значение пункта - Все
     * */
    const valuesAll = [-1, 'Все'];
    const dataValueField = this.options['dataValueField'] as string;
    const key = dataValueField in dataItem ? dataValueField : 'Value';
    const allElements = this.dataSource.data().map((el: IMultiSelectEvenItem) => el[key]);
    const valueSelected = dataItem[key] as number | string;

    const valueUpdate = (newValue: number[]) => {
        const scrollPos = this.ul.parent().scrollTop();

        this.value(newValue);

        if (newValue.length) {
            this.search();
            this.ul.parent().scrollTop(scrollPos);
        }
    };

    return {
        isAllItemSelect: valuesAll.includes(valueSelected),
        allElements,
        valuesAll,
        valueSelected,
        valueUpdate
    };
}

function onMultiSelectSelect(event: kendo.ui.MultiSelectDeselectEvent) {
    const {
        isAllItemSelect,
        allElements,
        valuesAll,
        valueUpdate,
        valueSelected
    } = dataMultiSelectEvent.call(this, event.dataItem);

    const elementsIncludeAll = allElements.some((i: string | number) => valuesAll.includes(i));
    const tagTemplateId = this.element.data('tag-template-id');
    const excludedTemplates = ['multiselectShowTextTagTemplate2WithoutAll', 'multiselectShowTextTagTemplate4WithoutAll'];

    if (!excludedTemplates.includes(tagTemplateId)) {
        this._maxTotal = elementsIncludeAll ? allElements.length : allElements.length + 1;
    }

    if (isAllItemSelect || (elementsIncludeAll && this.value().length === allElements.length - 2)) {
        const excludeNums = isAllItemSelect ? valuesAll : [valueSelected];
        valueUpdate(allElements.filter((num: number) => !excludeNums.includes(num)));
    }
}

function onMultiSelectDeselect(event: kendo.ui.MultiSelectDeselectEvent) {
    const {
        isAllItemSelect,
        valueSelected,
        valuesAll,
        valueUpdate
    } = dataMultiSelectEvent.call(this, event.dataItem);

    if (isAllItemSelect) {
        valueUpdate([valueSelected]);
    }
    else {
        setTimeout(() => {
            const scrollPos = this.ul.parent().scrollTop();
            const inputValue = event.sender.input.val() as string;
            valueUpdate(this.value().filter((num: number) => !valuesAll.includes(num)));
            if (inputValue) {
                event.sender.search(inputValue);
            }
            this.ul.parent().scrollTop(scrollPos);
        });
    }
}

/**
 * @description Обработчик события `dataBound` для Kendo MultiSelect.
 * Синхронизирует `_maxTotal` и, для `tagMode: "single"`, перерисовывает суммарный тег
 * после перезагрузки `dataSource`.
 *
 * @summary
 * **Для чего:**
 * Кастомный тег-шаблон в режиме `tagMode: "single"` отображает текст вида "выбрано X из Y",
 * где Y берётся из внутреннего свойства `_maxTotal`. Эта функция гарантирует,
 * что `_maxTotal` и визуальное представление суммарного тега всегда соответствуют
 * текущему набору данных.
 *
 * **Какую проблему решает:**
 * При перезагрузке данных (серверная фильтрация, смена параметров, повторный запрос)
 * Kendo MultiSelect НЕ пересчитывает `_maxTotal` автоматически и НЕ перерисовывает
 * HTML тегов. В результате суммарный тег-шаблон показывает устаревшее значение "из Y"
 * от предыдущего набора данных до тех пор, пока пользователь вручную не изменит выбор.
 *
 * **Почему так происходит:**
 * Kendo рассчитывает `_maxTotal` только при инициализации и при ручном выборе/снятии
 * элементов (select/deselect). Событие `dataBound` не затрагивает ни `_maxTotal`,
 * ни рендер тегов — это особенность внутренней реализации Kendo UI.
 * Поэтому необходимо вручную:
 * 1. Пересчитать `_maxTotal` через {@link refreshMultiSelectMaxTotal} — для всех режимов.
 * 2. Принудительно перерисовать HTML тегов через `_updateTagListHTML()` — **только для `tagMode: "single"`**.
 *
 * **Почему `_updateTagListHTML()` вызывается только для `tagMode: "single"`:**
 * В режиме `tagMode: "multiple"` (динамические селекты с серверной фильтрацией)
 * вызов `_updateTagListHTML()` после `dataBound` перерисовывает теги на основе
 * текущего DataSource, который содержит лишь результаты последнего поискового запроса.
 * Ранее выбранные элементы, отсутствующие в этом ответе, теряются из внутреннего
 * состояния виджета, что ломает отображение тегов (например, `[object HTMLInputElement]`)
 * и приводит к частичному удалению выбранных связей при сохранении формы.
 *
 * @param {kendo.ui.MultiSelectDataBoundEvent} e — объект события `dataBound`
 * @returns {void}
 *
 * @see {@link refreshMultiSelectMaxTotal} — пересчёт `_maxTotal`
 */
function onMultiSelectDataBound({ sender }: kendo.ui.MultiSelectDataBoundEvent): void {
    refreshMultiSelectMaxTotal(sender);

    if (sender.options.tagMode === 'single') {
        sender._updateTagListHTML?.();
    }
}

function refreshMultiSelectMaxTotal(ms: kendo.ui.MultiSelect): void {
    const tagTemplateId = ms.element.data('tag-template-id') as string | undefined;
    const excludedTemplates = ['multiselectShowTextTagTemplate2WithoutAll', 'multiselectShowTextTagTemplate4WithoutAll'];

    if (tagTemplateId && excludedTemplates.includes(tagTemplateId)) {
        return;
    }

    const allElements = ms.dataSource.data();
    const valuesAll = [-1, 'Все'];
    const dataValueField = ms.options.dataValueField ?? 'Value';
    const elementsIncludeAll = allElements.some((item: Record<string, string | number>) => {
        const key = dataValueField in item ? dataValueField : 'Value';
        return valuesAll.includes(item[key]);
    });

    ms._maxTotal = elementsIncludeAll ? allElements.length : allElements.length + 1;
}

window.onMultiSelectDataBound = onMultiSelectDataBound;
window.onMultiSelectDeselect = onMultiSelectDeselect;
window.onMultiSelectSelect = onMultiSelectSelect;
window.removeIsCatalogItems = removeIsCatalogItems;
window.updateDynamicMultiSelectItems = updateDynamicMultiSelectItems;
window.bindResizeHeightMultiSelect = bindResizeHeightMultiSelect;
window.msSelectAll = msSelectAll;
window.dynamicMultiSelectFilter = dynamicMultiSelectFilter;
window.refreshMultiSelectMaxTotal = refreshMultiSelectMaxTotal;
window.dynamicMultiselect_getData = dynamicMultiselect_getData;
